import qs from 'qs'
export default {
    httpGet(that,url,params,callback,error){
      that.$http.get(url, {params: params})
        .then(function (res) {
          // alert('ok')
            if(callback){
              callback(res.data)
            }
          }).catch(function (err) {
        // alert('err')
        console.log('err get' + err)
        if (typeof(error) != "undefined"){
          error(err)
        }
      })
    },
    httpPost(that,url,params,callback,error){

      // let currentparams = new URLSearchParams()
      //   alert(1)

        // console.log(qs)
        let currentparams = qs.stringify(params)
        // Object.keys(params).forEach(function(key){
        //     currentparams.append(key,params[key])
        //     // console.log(key,params[key]);
        //
        // });
        // console.log(currentparams)
      that.$http({
        method: 'post',
        url: url,
        data:currentparams
      }).then(function (res) {
        if(callback){
          callback(res.data)
        }
      }).catch(function (err) {
        console.log('err get' + err)
        if (typeof(error) != "undefined"){
          error(err)
        }
      })
    },
  httpDelete(that,url,params,callback,error){
    that.$http.delete(url, {params: params})
      .then(function (res) {
        if(callback){
          callback(res.data)
        }
      }).catch(function (err) {
      console.log('err get' + err)
      if (typeof(error) != "undefined"){
        error(err)
      }
    })
  },
  httpPut(that,url,params,callback,error){
      let currentparams = new URLSearchParams(params)
    that.$http.put(url,  currentparams)
      .then(function (res) {
        if(callback){
          callback(res.data)
        }
      }).catch(function (err) {
      console.log('err get' + err)
      if (typeof(error) != "undefined"){
        error(err)
      }
    })
  }


}



// WEBPACK FOOTER //
// ./src/service/base/httpUtil.js